import { get } from 'lodash-es';
import { createSelector } from 'reselect';

import { emptyArray } from 'ui-components/default-props/empty';

export const selectProductCategories = createSelector(
  ({ productCategories } = {}) => productCategories,
  (productCategories) => {
    if (!productCategories) {
      return emptyArray;
    }
    const result = Object.keys(productCategories).map((index) => productCategories[index]);
    return result.length === 0 ? emptyArray : result;
  },
);

const selectProductCategoryById = ({ productCategories }, props) => get(productCategories, props.categoryId);
export const selectProductCategoryPropertyById = (state, props) => get(selectProductCategoryById(state, props), props.property);
